import { render, staticRenderFns } from "./orderBuyFund.vue?vue&type=template&id=321d67d6"
import script from "./orderBuyFund.vue?vue&type=script&lang=js"
export * from "./orderBuyFund.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports